// extracted by mini-css-extract-plugin
export default {"customer-details__value":"customer-details_customer-details__value__2db1d"};